import React, { Fragment, useState, useCallback } from 'react'
import styled from '@emotion/styled'
import gsap from 'gsap'
import { rgba } from 'polished'
import Link from 'src/components/Link'
import Logo from 'src/components/Logo'
import Grid from 'src/components/Grid'
import ScrollListener from 'src/components/ScrollListener'
import NotificationBanner from 'src/components/NotificationBanner'
import ResponsiveComponent from 'src/components/ResponsiveComponent'
import AnimatedIcon from 'src/components/AnimatedIcon'
import MobileMenu from 'src/components/MobileMenu'
import Clock from 'react-live-clock';

import TransitionLink from 'gatsby-plugin-transition-link'
import AniLink from "gatsby-plugin-transition-link/AniLink";

import { colors, typography, animations, mq, util } from 'src/styles'

// import NavAbout from 'src/assets/images/nav_about.svg'
// import NavApply from 'src/assets/images/nav_apply.svg'
// import NavContact from 'src/assets/images/nav_contact.svg'
// import NavEvents from 'src/assets/images/nav_events.svg'
// import NavPortal from 'src/assets/images/nav_portal.svg'
// import NavProject from 'src/assets/images/nav_project.svg'
// import NavLogo from 'src/assets/images/vis-a-thon_logo.svg'


const Wrapper = styled.div`
	// width: 100%;
	// height: 100%;
	// position: fixed;
	// top: 0;
	// left: 0;
	// right: 0;
	// bottom: 0;
	// z-index: 4;
	// display: flex;
	a {
		${ typography.h3 }
		// font-family: ${ typography.secondaryFont };
		// background: dodgerblue;
		
	}
	${ mq.mediumAndBelow } {
		// width: 100vw;
	}
`

const ClockWrapper = styled.div`
  .clock {
    font-family: ${ typography.secondaryFont };
    font-size: 22px;
    color: ${ colors.green };
	}
	flex-grow: 1;
	text-align: center;
`

const sNavLinks = styled.ul`
	// position: absolute;
 //  top: 0;
 //  left: 0;

  background: red;

  // transform-origin: center;
  // transform: rotate(90deg) translate(50vh, 50vw);

  list-style: none;
  padding: 0;
  margin: 0;
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  width: 100%;
  // justify-content: ${ ({ alignment }) => alignment === 'right' ? 'flex-end' : 'flex-start' };
  li {
  	list-style: none;
    position: relative;
    flex-shrink: 0; 
    &:hover {
    }
    &:not(:last-of-type) {
      ${ util.responsiveStyles('margin-right', 60, 40, 20, 20) }
    }
  }
`


const NavLinks = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	// padding: 3vw 0;
	// width: 80%;
	// height: calc( 100% - 6vw);
	height: 100%;
	align-items: center;
	
`

const MenuIcon = styled.div`
	display: none;
	width: 100%;
  padding: 12px 18px;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  transition: color ${ animations.mediumSpeed } ease-in-out;
  span {
    display: block;
  }
`
const WestWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 3;
  width: 50px;
  height: 100vh;
  transition: width 0.5s ease, height 0.5s ease;

`

const NorthWrapper = styled.div`
	position: fixed;
	top: 0;
	right: 50px;
	left: 50px;
	height: 50px;
	z-index: 2;
	
	border-bottom: 1px solid white;
	${ ({ active }) => active != 'portal' ? `
		background: #000000;
		background: -webkit-linear-gradient(top, #000000, #FFFFFF00);
		background: -moz-linear-gradient(top, #000000, #FFFFFF00);
		background: linear-gradient(to bottom, #000000, #FFFFFF00);
	` : `` }
	${ mq.largeAndBelow } {
		border-bottom: 0px solid white;
		background: #000000;
		${ ({ mobileMenuOpen }) => mobileMenuOpen === true ? `
		` : `` }


		width: 100vw;
		left: 0;
		right: 0;
		> div {
			height: 100%;
			> div {
				height: 100%;
				a { 
					svg {
						height: 16px;
						fill: white;
					}
				}
			}
		}
	}

`

const SouthWrapper = styled.div`
	position: fixed;
	// top: 100%;
	bottom: 0;
	right: 50px;
	left: 50px;
	height: 50px;
	z-index: 2;
	border-top: 1px solid white;
	${ ({ active }) => active != 'portal' ? `
		// background: #000000;
		background: -webkit-linear-gradient(bottom, #000000, #FFFFFF00);
		background: -moz-linear-gradient(bottom, #000000, #FFFFFF00);
		background: linear-gradient(to top, #000000, #FFFFFF00);
	` : `` }
	${ mq.largeAndBelow } {
		border-top: 0px solid white;
		background: none #000000;
		${ ({ mobileMenuOpen }) => mobileMenuOpen === true ? `
		` : `` }

		// top: calc(100vh - 50px);
		width: 100vw;
		left: 0;
		right: 0;
		> div {
			height: 100%;
			> div {
				height: 100%;
			}
		}
	}
`


const EastWrapper = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	z-index: 3;
  width: 50px;
  height: 100vh;
  transition: width 0.75s ease, height 0.5s ease;
 
`

const LinkWrapperLeft = styled.div`
  position: relative;
	width: 100%;
	height: 100vh;

	border-right: 1px solid white;

	> div { 
		position: absolute;
		left: 14px;

		svg {
			transition: fill 0.75s ease;
			width: 16px;
			${ ({ active }) => active === true ? `
				fill: ${ colors.green };
			` : `
				fill: white;
			`}
		}
	}


  &:first-of-type {
		> div { 
			top: 21px;
		}
		
  }

  &:last-of-type {
		> div { 
			bottom: 21px;
		}
  }

  a {
  	&:hover {
  		svg {
	  		fill: ${ colors.green };
  		}
  	}
  }

`

const LinkWrapperRight = styled.div`
	position: relative;
	width: 50px;
	height: 100vh;

	border-left: 1px solid white;

	> div { 
		position: absolute;
		left: 17px;

		svg {
			transition: fill 0.75s ease;
			width: 16px;
			${ ({ active }) => active === true ? `
				fill: ${ colors.green };
			` : `
				fill: white;
			`}
		}
	}

  &:first-of-type {
		> div { 
			top: 19px;
		}
		
  }

  &:last-of-type {
		> div { 
			bottom: 21px;
		}
  }

  a {
  	&:hover {
  		svg {
	  		fill: ${ colors.green };
  		}
  	}
  }

`

const LinkWrapperCenter = styled.div`
	width: 100%;
	height: 50px;
	svg {
		transition: fill 0.75s ease;
		height: 16px;
		${ ({ active }) => active === true ? `
			fill: ${ colors.green };
		` : `
			fill: white;
		`}
	}
	
	position: relative;

	> a {
		position: absolute;
		top: 16px;
		${ ({ type }) => type === 'n' ? `
			right: 10px;
		` : `
			left: 10px;
		`}
	}
	a {
  	&:hover {
  		svg {
	  		fill: ${ colors.green };
  		}
  	}
	}
`

const LogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	svg {
		// margin-top: 14px;
	}
`

const TransLinkWrapper = styled.div`
	position: absolute:
	top: 10px;
	right: 0;
`

const StaticHeader = ({ 
	className,
  hasAtf = false,
  navigation,
  handleHoverState,
  active,
  mobileMenuOpen,
  toggleMobileMenu  }) => {

	  // const [ mobileMenuOpen, toggleMobileMenu ] = useState(false)
  	// const [ bannerVisible, toggleBanner ] = useState(false)
		const navLeft = navigation.slice(0,2)
    const navCenter = navigation.slice(2,4)
    const navRight = navigation.slice(4,6)

	  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

	  const westExitAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log(' EXIT animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;}
		        const t2 = gsap.timeline();
		        if ( index === 0 ) {
		        	t2.fromTo(node, { x: 0, y: 0 }, { x: w -25 ,y:h -25, duration: 2.5, ease: "none"} );
			        // t2.to(node, { x: w,y:h, duration: 2.5, ease: "none"});
		        } else {
		        	t2.fromTo(node, { x: 0, y: 0 }, { x: w -20 ,y: -h -20, duration: 2.5, ease: "none"} );
			        // t2.to(node, { x: w,y:-h, duration: 2.5, ease: "none"});
		        }
        	},
        [],
    );

    const westEntryAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log('ENTRY animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;}
		        const tl = gsap.timeline();
		        if ( index === 0 ) {
		        	tl.fromTo(node, {x:-w + 13,y:-h/2 + 13},{ x: 0,y:0, duration: 2.5, ease: "none"})
			        // tl.from(node,{x:-w,y:-h/2}).to(node,{ x: 0,y:0, duration: 2});
		        } else {
		        	tl.fromTo(node, {x:-w + 13,y:h/2 + 13},{ x: 0,y:0, duration: 2.5, ease: "none"})
			        // tl.from(node,{x:-w,y:h/2}).to(node,{ x: 0,y:0, duration: 2});
		        }
        	},
        [],
    );

    const eastExitAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log(' EXIT animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;}
		        const t2 = gsap.timeline();
		        if ( index === 0 ) {
			        // t2.to(node,{ x: -w,y:h});
			        t2.fromTo(node, { x: 0, y: 0 }, { x: -w +25 ,y:h +25, duration: 2.5, ease: "none"} );
		        } else {
			        // t2.to(node,{ x: -w,y:-h});
			        t2.fromTo(node, { x: 0, y: 0 }, { x: -w +20 ,y: -h +20, duration: 2.5, ease: "none"} );
		        }
        	},
        [],
    );

    const eastEntryAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log('ENTRY animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;
          }
		        const tl = gsap.timeline();
		        if ( index === 0 ) {
			        // tl.from(node,2,{x:w,y:-h/2}).to(node,1,{ x: 0,y:0});
			        tl.fromTo(node, {x: w - 13 , y: -h/2 - 13},{ x: 0,y:0, duration: 2.5, ease: "none"})
		        } else {
			        // tl.from(node,2,{x:w,y:h/2}).to(node,1,{ x: 0,y:0});
			        tl.fromTo(node, {x: w - 13, y: h/2 - 13},{ x: 0,y:0, duration: 2.5, ease: "none"})
		        }
        	},
        [],
    );

    const northExitAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log(' EXIT animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;}
		        const t2 = gsap.timeline();
		        t2.to(node,2,{ x: 0,y:-h});
        	},
        [],
    );

    const northEntryAnimation = useCallback(
        (node, e, exit, entry, index) => {
        	console.log('ENTRY animation::::', index)
          if(window !=="undefined") {
            var w = window.innerWidth; 
            var h = window.innerHeight;}
		        const tl = gsap.timeline();
		        tl.from(node,2,{x:0,y:h}).to(node,1,{ x: 0,y:0});
        	},
        [],
    );

    if ( typeof window !== 'undefined' ) {
	  	return (
		    <Wrapper className='static-header' id="static-header">

	      	

	      	<ResponsiveComponent
            medium={
            	<Fragment>
	            	<NorthWrapper active={active} className="north-wrapper" mobileMenuOpen={mobileMenuOpen}>
				      		<div>
					      		<div>
						      		<LogoWrapper>
				              	<Link
			                    to={'/'}
			                  >
				              		<svg width="124" height="16" viewBox="0 0 124 16" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M13.332 0.336H11.528L7.04 12.744L2.574 0.336H0.792L6.402 16H7.7L13.332 0.336ZM16.9752 16V0.336H15.4132V16H16.9752ZM31.9578 3.922L28.4818 0.336H22.9378L19.7258 3.636V7.332L23.1138 9.048H27.9758L29.9558 10.082V11.974L27.7558 14.24H23.6638L20.6718 11.138L19.4398 12.414L22.9378 16H28.4818L31.6718 12.7V9.004L28.3938 7.288H23.5098L21.4418 6.232V4.362L23.6638 2.096H27.7558L30.7478 5.198L31.9578 3.922ZM42.4469 8.982V7.354H33.4709V8.982H42.4469ZM56.11 16L50.478 0.336H49.18L43.57 16H45.352L47.002 11.468H52.656L54.306 16H56.11ZM52.04 9.708H47.64L49.818 3.592L52.04 9.708ZM66.1992 8.982V7.354H57.2232V8.982H66.1992ZM79.4442 2.096V0.336H67.5202V2.096H72.6242V16H74.3402V2.096H79.4442ZM93.6746 16V0.336H91.9586V7.288H83.4446V0.336H81.7286V16H83.4446V9.048H91.9586V16H93.6746ZM108.672 12.7V3.636L105.46 0.336H99.9381L96.7261 3.636V12.7L99.9381 16H105.46L108.672 12.7ZM106.956 11.974L104.756 14.24H100.642L98.4421 11.974V4.362L100.642 2.096H104.756L106.956 4.362V11.974ZM123.679 16V0.336H121.963V12.546L113.097 0.336H111.733V16H113.449V3.79L122.315 16H123.679Z"/>
													</svg>
			                  </Link>
			              	</LogoWrapper>

					          </div>
				      		</div>

				      	</NorthWrapper>

				      	<WestWrapper active={active} className="west-wrapper">
				      		<NavLinks alignment="left">
						      	<MenuIcon id="mobile-menu-icon" onClick={() => {toggleMobileMenu(!mobileMenuOpen); }}>
		                  <AnimatedIcon
		                    icon={mobileMenuOpen ? 'close' : 'menu'}
		                  />
		                </MenuIcon>
				      		</NavLinks>
			      		</WestWrapper>

	              <MobileMenu
			            open={mobileMenuOpen}
			            toggleMobileMenu={toggleMobileMenu}
			            navLinks={navigation}
			          // footerColumn1={footerColumn1}
			          // footerColumn2={footerColumn2}
			          />

				        <SouthWrapper active={active} className="south-wrapper" mobileMenuOpen={mobileMenuOpen}>
					        <div>
						        <div>
					          	<LogoWrapper>
				              	<ClockWrapper>
								          <Clock className="clock" format={'HH:mm:ss zz'} ticking={true} timezone={timezone} />
								      	</ClockWrapper>
			              	</LogoWrapper>
		              	</div>
	              	</div>
	            	</SouthWrapper>
            	</Fragment>
            }
            large={
            	<Fragment>
            		<NorthWrapper active={active} className="north-wrapper" mobileMenuOpen={mobileMenuOpen}>
				      		<div>
					      		<div>
						      		<LinkWrapperCenter active={active === navCenter[0].to.slug ? true : false} type='n'>
				              	
				              	<LogoWrapper>

				              		<TransitionLink
													  to={'/'}
													  exit={{
													    trigger: ({ node, e, exit, entry  }) => northExitAnimation(node, e, exit, entry),
													    length: 1
													  }}
													  entry={{
													  	trigger: ({ node, e, exit, entry }) => northEntryAnimation(node, e, exit, entry),
													  	length: 1
													  }}
													>
														<svg width="124" height="16" viewBox="0 0 124 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M13.332 0.336H11.528L7.04 12.744L2.574 0.336H0.792L6.402 16H7.7L13.332 0.336ZM16.9752 16V0.336H15.4132V16H16.9752ZM31.9578 3.922L28.4818 0.336H22.9378L19.7258 3.636V7.332L23.1138 9.048H27.9758L29.9558 10.082V11.974L27.7558 14.24H23.6638L20.6718 11.138L19.4398 12.414L22.9378 16H28.4818L31.6718 12.7V9.004L28.3938 7.288H23.5098L21.4418 6.232V4.362L23.6638 2.096H27.7558L30.7478 5.198L31.9578 3.922ZM42.4469 8.982V7.354H33.4709V8.982H42.4469ZM56.11 16L50.478 0.336H49.18L43.57 16H45.352L47.002 11.468H52.656L54.306 16H56.11ZM52.04 9.708H47.64L49.818 3.592L52.04 9.708ZM66.1992 8.982V7.354H57.2232V8.982H66.1992ZM79.4442 2.096V0.336H67.5202V2.096H72.6242V16H74.3402V2.096H79.4442ZM93.6746 16V0.336H91.9586V7.288H83.4446V0.336H81.7286V16H83.4446V9.048H91.9586V16H93.6746ZM108.672 12.7V3.636L105.46 0.336H99.9381L96.7261 3.636V12.7L99.9381 16H105.46L108.672 12.7ZM106.956 11.974L104.756 14.24H100.642L98.4421 11.974V4.362L100.642 2.096H104.756L106.956 4.362V11.974ZM123.679 16V0.336H121.963V12.546L113.097 0.336H111.733V16H113.449V3.79L122.315 16H123.679Z"/>
														</svg>
													</TransitionLink>
												{/*
					              	<Link
				                    to={'/'}
				                  >
					              		<svg width="124" height="16" viewBox="0 0 124 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M13.332 0.336H11.528L7.04 12.744L2.574 0.336H0.792L6.402 16H7.7L13.332 0.336ZM16.9752 16V0.336H15.4132V16H16.9752ZM31.9578 3.922L28.4818 0.336H22.9378L19.7258 3.636V7.332L23.1138 9.048H27.9758L29.9558 10.082V11.974L27.7558 14.24H23.6638L20.6718 11.138L19.4398 12.414L22.9378 16H28.4818L31.6718 12.7V9.004L28.3938 7.288H23.5098L21.4418 6.232V4.362L23.6638 2.096H27.7558L30.7478 5.198L31.9578 3.922ZM42.4469 8.982V7.354H33.4709V8.982H42.4469ZM56.11 16L50.478 0.336H49.18L43.57 16H45.352L47.002 11.468H52.656L54.306 16H56.11ZM52.04 9.708H47.64L49.818 3.592L52.04 9.708ZM66.1992 8.982V7.354H57.2232V8.982H66.1992ZM79.4442 2.096V0.336H67.5202V2.096H72.6242V16H74.3402V2.096H79.4442ZM93.6746 16V0.336H91.9586V7.288H83.4446V0.336H81.7286V16H83.4446V9.048H91.9586V16H93.6746ZM108.672 12.7V3.636L105.46 0.336H99.9381L96.7261 3.636V12.7L99.9381 16H105.46L108.672 12.7ZM106.956 11.974L104.756 14.24H100.642L98.4421 11.974V4.362L100.642 2.096H104.756L106.956 4.362V11.974ZM123.679 16V0.336H121.963V12.546L113.097 0.336H111.733V16H113.449V3.79L122.315 16H123.679Z"/>
														</svg>
				                  </Link>
			                  */}
				              	</LogoWrapper>

					              	<TransitionLink
													  to={'/' + navCenter[0].to.slug}
													  exit={{
													    trigger: ({ node, e, exit, entry  }) => northExitAnimation(node, e, exit, entry),
													    length: 1
													  }}
													  entry={{
													  	trigger: ({ node, e, exit, entry }) => northEntryAnimation(node, e, exit, entry),
													  	length: 1
													  }}
													>
													  <svg viewBox="0 0 82 16" fill="none">
														<path d="M11.9677 16V14.24H1.73768V9.048H7.65568V7.288H1.73768V2.096H11.9677V0.336H0.021675V16H11.9677ZM25.6909 4.076V0.336H23.9529V3.614L19.7069 13.25L15.4609 3.614V0.336H13.7449V4.076L19.0909 16H20.3449L25.6909 4.076ZM40.3821 16V14.24H30.1521V9.048H36.0701V7.288H30.1521V2.096H40.3821V0.336H28.4361V16H40.3821ZM54.5892 16V0.336H52.9612V10.698L44.2492 3.35V0.336H42.6432V16H44.2712L44.2492 5.616L52.9612 12.986V16H54.5892ZM68.7947 2.096V0.336H56.8707V2.096H61.9747V16H63.6907V2.096H68.7947ZM81.8168 3.922L78.3408 0.336H72.7968L69.5848 3.636V7.332L72.9728 9.048H77.8348L79.8148 10.082V11.974L77.6148 14.24H73.5228L70.5308 11.138L69.2988 12.414L72.7968 16H78.3408L81.5308 12.7V9.004L78.2528 7.288H73.3688L71.3008 6.232V4.362L73.5228 2.096H77.6148L80.6068 5.198L81.8168 3.922Z"/>
														</svg>

													</TransitionLink>
			                </LinkWrapperCenter>

					          </div>
				      		</div>

				      	</NorthWrapper>
				        
				      	<WestWrapper active={active} className="west-wrapper">
				      		<NavLinks alignment="left">
				      			{
				              	navLeft && navLeft.map((link, index) => {
				              		return (
						                <LinkWrapperLeft key={'header-link-' + link.id} active={active === link.to.slug ? true : false}>
						                	<div>
							                  <TransitionLink
																  to={'/' + link.to.slug}
																  exit={{
																    trigger: ({ node, e, exit, entry  }) => westExitAnimation(node, e, exit, entry, index),
																    length: 2.5
																  }}
																  entry={{
																  	trigger: ({ node, e, exit, entry }) => westEntryAnimation(node, e, exit, entry, index),
																  	length: 2.5
																  }}
																>
																	{ link.label === 'About' ? (
																	 	<svg viewBox="0 0 16 72" fill="none">
																		<path d="M16 59.096L3.636 59.096L0.335999 62.308L0.336 67.83L3.636 71.042L16 71.042L16 69.326L9.048 69.326L9.048 60.812L16 60.812L16 59.096ZM7.288 60.812L7.288 69.326L4.362 69.326L2.096 67.126L2.096 63.012L4.362 60.812L7.288 60.812ZM12.7 43.9005L9.004 43.9005L8.168 45.5505L7.332 43.9005L3.636 43.9005L0.335999 47.1125L0.335999 55.8465L16 55.8465L16 47.1125L12.7 43.9005ZM6.232 45.6165L7.288 47.6625L7.288 54.1305L2.096 54.1305L2.096 47.8165L4.362 45.6165L6.232 45.6165ZM11.974 45.6165L14.24 47.8165L14.24 54.1305L9.048 54.1305L9.048 47.6625L10.104 45.6165L11.974 45.6165ZM12.7 29.0964L3.636 29.0964L0.335998 32.3084L0.335998 37.8304L3.636 41.0424L12.7 41.0424L16 37.8304L16 32.3084L12.7 29.0964ZM11.974 30.8124L14.24 33.0124L14.24 37.1264L11.974 39.3264L4.362 39.3264L2.096 37.1264L2.096 33.0124L4.362 30.8124L11.974 30.8124ZM12.7 14.1997L0.335997 14.1997L0.335997 15.9157L11.974 15.9157L14.24 18.1157L14.24 22.2077L11.974 24.4077L0.335998 24.4077L0.335998 26.1237L12.7 26.1237L16 22.9117L16 17.4117L12.7 14.1997ZM2.096 0.0775614L0.335997 0.0775615L0.335997 12.0016L2.096 12.0016L2.096 6.89756L16 6.89756L16 5.18156L2.096 5.18156L2.096 0.0775614Z" />
																		</svg>
																	) : (
																		<svg viewBox="0 0 16 68" fill="none">
																		<path d="M16 55.096L3.636 55.096L0.335999 58.308L0.336 63.83L3.636 67.042L16 67.042L16 65.326L9.048 65.326L9.048 56.812L16 56.812L16 55.096ZM7.288 56.812L7.288 65.326L4.362 65.326L2.096 63.126L2.096 59.012L4.362 56.812L7.288 56.812ZM7.332 39.9005L3.636 39.9005L0.335999 43.1125L0.335999 51.8465L16 51.8465L16 50.1305L9.048 50.1305L9.048 43.2225L7.332 39.9005ZM6.232 41.6165L7.288 43.6625L7.288 50.1305L2.096 50.1305L2.096 43.8165L4.362 41.6165L6.232 41.6165ZM7.332 25.1777L3.636 25.1777L0.335998 28.3897L0.335998 37.1237L16 37.1237L16 35.4077L9.048 35.4077L9.048 28.4997L7.332 25.1777ZM6.232 26.8937L7.288 28.9397L7.288 35.4077L2.096 35.4077L2.096 29.0937L4.362 26.8937L6.232 26.8937ZM16 10.4549L14.24 10.4549L14.24 20.6849L0.335998 20.6849L0.335998 22.4009L16 22.4009L16 10.4549ZM4.274 0.727811L0.335997 0.727811L0.335997 2.46581L3.438 2.46581L6.958 6.71181L3.438 10.9578L0.335997 10.9578L0.335997 12.6738L4.274 12.6738L8.498 7.56981L16 7.56981L16 5.85381L8.498 5.85381L4.274 0.727811Z"/>
																		</svg>
																	)}
																</TransitionLink>
						                  </div>
						                </LinkWrapperLeft>
				              		)
				              	})
				            }
				          </NavLinks>
				      	</WestWrapper>


				        <EastWrapper active={active} className="east-wrapper">
				          <NavLinks alignment="right">
				            {navRight && navRight.map((link, index) => {
				              	return (
				                  <LinkWrapperRight key={'header-link-' + link.id} active={active === link.to.slug ? true : false}>
				  	                <div>
				  	                	<TransitionLink
				  										  to={'/' + link.to.slug}
				  										  exit={{
				  										    trigger: ({ node, e, exit, entry  }) => eastExitAnimation(node, e, exit, entry, index),
				  										    length: 2.5
				  										  }}
				  										  entry={{
				  										  	trigger: ({ node, e, exit, entry }) => eastEntryAnimation(node, e, exit, entry, index),
				  										  	length: 2.5
				  										  }}
				  										>
				  										  { link.label === 'Contact' ? (
																 	<svg viewBox="0 0 16 93" fill="none">
																	<path d="M3.608 12.992L4.84 11.76L1.76 8.79L1.76 4.676L4.026 2.476L11.638 2.476L13.904 4.676L13.904 8.79L10.802 11.782L12.078 12.97L15.664 9.494L15.664 3.972L12.364 0.76L3.3 0.759999L-2.17333e-07 3.972L-4.58707e-07 9.494L3.608 12.992ZM3.3 27.2355L12.364 27.2355L15.664 24.0235L15.664 18.5015L12.364 15.2895L3.3 15.2895L-8.52436e-07 18.5015L-1.09381e-06 24.0235L3.3 27.2355ZM4.026 25.5195L1.76 23.3195L1.76 19.2055L4.026 17.0055L11.638 17.0055L13.904 19.2055L13.904 23.3195L11.638 25.5195L4.026 25.5195ZM-1.89018e-06 42.2422L15.664 42.2422L15.664 40.5262L3.454 40.5262L15.664 31.6602L15.664 30.2962L-1.368e-06 30.2962L-1.44301e-06 32.0122L12.21 32.0122L-1.83055e-06 40.8782L-1.89018e-06 42.2422ZM13.904 56.4477L15.664 56.4477L15.664 44.5237L13.904 44.5237L13.904 49.6277L-2.21301e-06 49.6277L-2.28801e-06 51.3437L13.904 51.3437L13.904 56.4477ZM-3.00109e-06 67.6568L15.664 62.0248L15.664 60.7268L-2.45295e-06 55.1168L-2.53084e-06 56.8988L4.532 58.5488L4.532 64.2028L-2.92223e-06 65.8528L-3.00109e-06 67.6568ZM6.292 63.5868L6.292 59.1868L12.408 61.3648L6.292 63.5868ZM3.608 80.9772L4.84 79.7452L1.76 76.7752L1.76 72.6612L4.026 70.4612L11.638 70.4612L13.904 72.6612L13.904 76.7752L10.802 79.7672L12.078 80.9552L15.664 77.4792L15.664 71.9572L12.364 68.7452L3.3 68.7452L-3.18906e-06 71.9572L-3.43043e-06 77.4792L3.608 80.9772ZM13.904 92.9462L15.664 92.9462L15.664 81.0222L13.904 81.0222L13.904 86.1262L-3.80841e-06 86.1262L-3.88342e-06 87.8422L13.904 87.8422L13.904 92.9462Z"/>
																	</svg>
																) : (
																	<svg viewBox="0 0 16 111" fill="none">
																	<path d="M8.668 12.904L12.364 12.904L15.664 9.692L15.664 0.958L-8.55869e-08 0.957999L-1.60596e-07 2.674L6.952 2.674L6.952 9.582L8.668 12.904ZM9.768 11.188L8.712 9.142L8.712 2.674L13.904 2.674L13.904 8.988L11.638 11.188L9.768 11.188ZM-1.26478e-06 27.9348L7.414 25.2068L8.668 27.6268L12.364 27.6268L15.664 24.4148L15.664 15.6808L-7.29142e-07 15.6808L-8.0415e-07 17.3968L6.952 17.3968L6.952 23.5568L-1.18496e-06 26.1088L-1.26478e-06 27.9348ZM9.768 25.9108L8.712 23.8648L8.712 17.3968L13.904 17.3968L13.904 23.7108L11.638 25.9108L9.768 25.9108ZM3.3 42.1516L12.364 42.1516L15.664 38.9396L15.664 33.4176L12.364 30.2056L3.3 30.2056L-1.50444e-06 33.4176L-1.74582e-06 38.9396L3.3 42.1516ZM4.026 40.4356L1.76 38.2356L1.76 34.1216L4.026 31.9216L11.638 31.9216L13.904 34.1216L13.904 38.2356L11.638 40.4356L4.026 40.4356ZM3.3 56.1684L15.664 56.1684L15.664 49.3484L13.904 49.3484L13.904 54.4524L4.026 54.4524L1.76 52.2524L1.76 48.1604L4.862 45.1464L3.586 43.9364L-2.11713e-06 47.4344L-2.35851e-06 52.9564L3.3 56.1684ZM-3.1585e-06 71.2581L1.76 71.2581L1.76 61.0281L6.952 61.0281L6.952 66.9461L8.712 66.9461L8.712 61.0281L13.904 61.0281L13.904 71.2581L15.664 71.2581L15.664 59.3121L-2.63633e-06 59.3121L-3.1585e-06 71.2581ZM3.608 85.0592L4.84 83.8272L1.76 80.8572L1.76 76.7432L4.026 74.5432L11.638 74.5432L13.904 76.7432L13.904 80.8572L10.802 83.8492L12.078 85.0372L15.664 81.5612L15.664 76.0392L12.364 72.8272L3.3 72.8272L-3.36749e-06 76.0392L-3.60886e-06 81.5612L3.608 85.0592ZM13.904 97.0282L15.664 97.0282L15.664 85.1042L13.904 85.1042L13.904 90.2082L-3.98684e-06 90.2082L-4.06185e-06 91.9242L13.904 91.9242L13.904 97.0282ZM12.078 110.05L15.664 106.574L15.664 101.03L12.364 97.8183L8.668 97.8183L6.952 101.206L6.952 106.068L5.918 108.048L4.026 108.048L1.76 105.848L1.76 101.756L4.862 98.7643L3.586 97.5323L-4.45989e-06 101.03L-4.70222e-06 106.574L3.3 109.764L6.996 109.764L8.712 106.486L8.712 101.602L9.768 99.5343L11.638 99.5343L13.904 101.756L13.904 105.848L10.802 108.84L12.078 110.05Z"/>
																	</svg>
																)}
				  										</TransitionLink>
				  	                </div>
				                  </LinkWrapperRight>
				                )
				  						})
				  					}
				          </NavLinks>

				        </EastWrapper>

				        <SouthWrapper active={active} className="south-wrapper" mobileMenuOpen={mobileMenuOpen}>
				      		<div>
					      		<div>
						            <LinkWrapperCenter active={active === navCenter[0].to.slug ? true : false}>
					              	<LogoWrapper>
						              	<ClockWrapper>
										          <Clock className="clock" format={'HH:mm:ss zz'} ticking={true} timezone={timezone} />
										      	</ClockWrapper>
					              	</LogoWrapper>

						              	<Link
				                    to={'/' + navCenter[1].to.slug}
				                    key={navCenter[1].to.slug}
				                  >
				                    <svg viewBox="0 0 84 16" fill="none" >
														<path d="M12.904 7.332V3.636L9.692 0.336H0.958V16H2.674V9.048H9.582L12.904 7.332ZM11.188 6.232L9.142 7.288H2.674V2.096H8.988L11.188 4.362V6.232ZM27.4288 12.7V3.636L24.2168 0.336H18.6948L15.4828 3.636V12.7L18.6948 16H24.2168L27.4288 12.7ZM25.7128 11.974L23.5128 14.24H19.3988L17.1988 11.974V4.362L19.3988 2.096H23.5128L25.7128 4.362V11.974ZM42.4356 16V12.062L38.8496 9.048H39.1136L42.4356 7.332V3.636L39.2236 0.336H30.4896V16H32.2056V9.048H36.2096L40.7196 12.898V16H42.4356ZM40.7196 6.232L38.6736 7.288H32.2056V2.096H38.5196L40.7196 4.362V6.232ZM55.0512 2.096V0.336H43.1272V2.096H48.2312V16H49.9472V2.096H55.0512ZM68.2933 16V3.636L65.0813 0.336H59.5593L56.3473 3.636V16H58.0633V9.048H66.5773V16H68.2933ZM66.5773 7.288H58.0633V4.362L60.2633 2.096H64.3773L66.5773 4.362V7.288ZM83.4888 16V14.24H73.2588V0.336H71.5428V16H83.4888Z"/>
														</svg>

				                  </Link>
				                </LinkWrapperCenter>
					          </div>
				      		</div>
					       	

				      	</SouthWrapper>
            	</Fragment>
          	}
          />

		    </Wrapper>
		  )
		} else {
			return (
				<div></div>
			)
		}
  }
export default StaticHeader
